module.exports = __webpack_public_path__ + "media/images/pages/get-involved/impact_report-0f658042dedd9fd7769c1aec520e947a.png";